import { AxiosRequestConfig } from 'axios';

import {
  CustomCalculateRequestType,
  CustomCalculateResponseType,
} from '~/shared/api/types/catalog';
import { api } from '~/shared/lib/api';

export const customCalculate = async (
  params: CustomCalculateRequestType,
  options: AxiosRequestConfig<CustomCalculateRequestType> = {},
) => {
  const { data } = await api.post<CustomCalculateResponseType>(
    '/api/v1/custom-payment/calculate',
    params,
    options,
  );

  return data;
};
